import type { CommentModel } from '../types';
import { apiPatch } from './api-client';

const apiName = 'avaniV2HttpApi';
const path = 'faults';

export const markFaultAsResolved = async (faultId: string, comment: CommentModel): Promise<any> => {
  return apiPatch(apiName, `${path}/${faultId}/mark-resolved`, { comment });
};

export const resolveFault = async (faultId: string, visitId: string, comment: CommentModel): Promise<any> => {
  return apiPatch(apiName, `${path}/${faultId}/resolve`, { comment, visitId });
};

export const postResolveFault = async (faultId: string, comment: CommentModel): Promise<any> => {
  return apiPatch(apiName, `${path}/${faultId}/post-resolve`, { comment });
};
